import objectAssign from 'object-assign';

export const assign = (target: any, sources: any) => {
    if (!sources) {
        return target;
    }

    if (Array.isArray(sources)) {
        for (let item of sources) {
            if (isObject(item)) {
                target.push(assignObjectDeep({}, item));
            } else if (Array.isArray(item)) {
                target.push(assign([], item));
            } else {
                target.push(item);
            }
        }
    } else if (sources instanceof Date) {
        target.push(sources);
    } else if (isObject(sources)) {
        return assignObjectDeep(target, sources);
    }

    return target;
};

const assignObjectDeep = (target: any, item: any) => {
    target = objectAssign({}, item);

    for (let key in item) {
        if (Array.isArray(item[key])) {
            target[key] = assign([], item[key]);
        } else if (item[key] instanceof Date) {
            target[key] = item[key].ToBrowserDate();
        } else if (isObject(item[key])) {
            target[key] = assignObjectDeep({}, item[key]);
        }
    }

    return target;
};

const isObject = (item: any) => {
    return item && typeof item === 'object' && !Array.isArray(item);
};
